//
//
//
//
//
//
//

var script = {
  name:"HkepHello"
}

/* script */
            const __vue_script__ = script;
            
/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hello"},[_vm._v("HkepHello.vue")]),_vm._v(" "),_c('h1',[_vm._v("This is Testing Hello Compo "+_vm._s(_vm.input)+" ")])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-a999ad42_0", { source: "\nh1[data-v-a999ad42]{color:red\n}\n.hello[data-v-a999ad42]{background:#eacf7d;padding:10px\n}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-a999ad42";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* component normalizer */
  function __vue_normalize__(
    template, style, script$$1,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "HkepHello.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    {
      let hook;
      if (style) {
        hook = function(context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render;
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context)
          };
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate;
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const head = document.head || document.getElementsByTagName('head')[0];
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {});
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id;
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

      if (!style.ids.includes(id)) {
        let code = css.source;
        let index = style.ids.length;

        style.ids.push(id);

        if (css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */';
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']');
        }

        if (!style.element) {
          const el = style.element = document.createElement('style');
          el.type = 'text/css';

          if (css.media) el.setAttribute('media', css.media);
          if (isOldIE) {
            el.setAttribute('data-group', group);
            el.setAttribute('data-next-index', '0');
          }

          head.appendChild(el);
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'));
          style.element.setAttribute('data-next-index', index + 1);
        }

        if (style.element.styleSheet) {
          style.parts.push(code);
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n');
        } else {
          const textNode = document.createTextNode(code);
          const nodes = style.element.childNodes;
          if (nodes[index]) style.element.removeChild(nodes[index]);
          if (nodes.length) style.element.insertBefore(textNode, nodes[index]);
          else style.element.appendChild(textNode);
        }
      }
    }
  }
  /* style inject SSR */
  

  
  var HkepHello = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    __vue_create_injector__,
    undefined
  )

//
//
//
//
//
//
//

var script$1 = {
  name:"HkepHello",	
  props: ['input']
}

/* script */
            const __vue_script__$1 = script$1;
            
/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"world"},[_vm._v("HkepWorld.vue")]),_vm._v(" "),_c('h1',[_vm._v("This is Testing World Compo "+_vm._s(_vm.input)+" ")])])};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-ae3242d8_0", { source: "\nh1[data-v-ae3242d8]{color:#00f\n}\n.world[data-v-ae3242d8]{background:#fcd;padding:10px\n}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = "data-v-ae3242d8";
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* component normalizer */
  function __vue_normalize__$1(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "HkepWorld.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    {
      let hook;
      if (style) {
        hook = function(context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render;
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context)
          };
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate;
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__$1() {
    const head = document.head || document.getElementsByTagName('head')[0];
    const styles = __vue_create_injector__$1.styles || (__vue_create_injector__$1.styles = {});
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id;
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

      if (!style.ids.includes(id)) {
        let code = css.source;
        let index = style.ids.length;

        style.ids.push(id);

        if (css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */';
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']');
        }

        if (!style.element) {
          const el = style.element = document.createElement('style');
          el.type = 'text/css';

          if (css.media) el.setAttribute('media', css.media);
          if (isOldIE) {
            el.setAttribute('data-group', group);
            el.setAttribute('data-next-index', '0');
          }

          head.appendChild(el);
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'));
          style.element.setAttribute('data-next-index', index + 1);
        }

        if (style.element.styleSheet) {
          style.parts.push(code);
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n');
        } else {
          const textNode = document.createTextNode(code);
          const nodes = style.element.childNodes;
          if (nodes[index]) style.element.removeChild(nodes[index]);
          if (nodes.length) style.element.insertBefore(textNode, nodes[index]);
          else style.element.appendChild(textNode);
        }
      }
    }
  }
  /* style inject SSR */
  

  
  var HkepWorld = __vue_normalize__$1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    __vue_create_injector__$1,
    undefined
  )

//
//
//
//
//
//
//
//


var script$2 = {
    name: "HkepLoading",
    props: {
        color:String,
        size:String
    },
    data() {
        return {
            isShow:false
        }
    },
    computed: {
        styleSpinner() {
            return {
                width:`${this.size}px`,
                height:`${this.size}px`,
                border:`3px solid ${this.borderColor}`,
                borderTopColor: `${this.color}`,
                marginLeft: `${-0.5 * this.size}px`,
                marginTop: `${-0.5 * this.size}px`,
            }
        },
        borderColor () {
            let rgba = this.hexToRgba(this.color);
            return `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, .2)`;
        }
    },
    mounted() {
       
    },
    methods: {
        show() {
            this.isShow = true;
        },
        hide() {
            this.isShow = false;
        },
        /**
         * //TODO: Move to color util library
         * @param str
         * @returns {*[]}
         */
        hexToRgba (str) {
            var regex = /^\#?([\da-fA-F]+)$/;
            var hex = regex.exec(str)[1];

            if (hex.length === 3) {
                hex = hex.replace(/([a-zA-Z0-9])/g, '$1$1');
            }

            var n = parseInt(hex, 16);

            return [
                (n & 0xFF0000) >> 16,
                (n & 0xFF00) >> 8,
                n & 0xFF,
                1
            ]
        }
    }
}

/* script */
            const __vue_script__$2 = script$2;
            
/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],attrs:{"id":"loading"}},[_c('div',{style:(_vm.styleSpinner),attrs:{"id":"spinner"}})])};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = function (inject) {
    if (!inject) return
    inject("data-v-8fb72d68_0", { source: "\n#loading[data-v-8fb72d68]{position:fixed;z-index:9999;background:rgba(255,255,255,.6);left:0;top:0;width:100%;height:100%\n}\n#spinner[data-v-8fb72d68]{position:absolute;display:inline-block;width:50px;height:50px;left:50%;top:50%;border:3px solid rgba(255,255,255,.3);border-radius:50%;border-top-color:#fff;animation:spin-data-v-8fb72d68 1s ease-in-out infinite;-webkit-animation:spin-data-v-8fb72d68 1s ease-in-out infinite\n}\n@keyframes spin-data-v-8fb72d68{\nto{-webkit-transform:rotate(360deg)\n}\n}\n@-webkit-keyframes spin-data-v-8fb72d68{\nto{-webkit-transform:rotate(360deg)\n}\n}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$2 = "data-v-8fb72d68";
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* component normalizer */
  function __vue_normalize__$2(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "HkepLoading.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    {
      let hook;
      if (style) {
        hook = function(context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render;
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context)
          };
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate;
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__$2() {
    const head = document.head || document.getElementsByTagName('head')[0];
    const styles = __vue_create_injector__$2.styles || (__vue_create_injector__$2.styles = {});
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id;
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

      if (!style.ids.includes(id)) {
        let code = css.source;
        let index = style.ids.length;

        style.ids.push(id);

        if (css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */';
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']');
        }

        if (!style.element) {
          const el = style.element = document.createElement('style');
          el.type = 'text/css';

          if (css.media) el.setAttribute('media', css.media);
          if (isOldIE) {
            el.setAttribute('data-group', group);
            el.setAttribute('data-next-index', '0');
          }

          head.appendChild(el);
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'));
          style.element.setAttribute('data-next-index', index + 1);
        }

        if (style.element.styleSheet) {
          style.parts.push(code);
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n');
        } else {
          const textNode = document.createTextNode(code);
          const nodes = style.element.childNodes;
          if (nodes[index]) style.element.removeChild(nodes[index]);
          if (nodes.length) style.element.insertBefore(textNode, nodes[index]);
          else style.element.appendChild(textNode);
        }
      }
    }
  }
  /* style inject SSR */
  

  
  var HkepLoading = __vue_normalize__$2(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    __vue_create_injector__$2,
    undefined
  )

//
//
//
//


var script$3 = {
    name: "MyFolder",
    props: [
        'showTrash',
        'mime_type',
        'common',
        'api',
        'webix_functions',
        "content_type_function",
        'status'
    ],
    data: function () {
        return {
            item_select: [],
            resource_list: [],
            content_type_list: [],
            count: 0,
            search_resource_list: [],
            subject_list: [
                {
                    "id": "null",
                    "value": "所有科目"
                }
            ]
        }
    },
    mounted() {
        let self = this;
        self.getResource();

        //listen event
        EventBus.$on("add_to_bookmark", function(ids){
            self.add_to_bookmark(ids);
        });
    },
    methods: {
        //取得該用戶有什麼資源
        getResource: function()
        {
            let self = this;
            EventBus.$emit("showGlobalLoading");

            axios.all([
                self.api.getSubjects(),
                self.api.getMyFolderByMemberId(1234),
                self.api.getContentTypeListing("group")]
            ).then(
                axios.spread(
                    function (subject_resp, my_folder_resp, content_type_resp) {

                        if (subject_resp) {
                            subject_resp.data.forEach(function(obj) {
                                self.subject_list.push(obj);
                            });

                        }

                        // Both requests are now complete
                        if (my_folder_resp.data) {
                            self.count = my_folder_resp.data.count;
                            if (my_folder_resp.data.data) {
                                self.setResourceList(my_folder_resp.data.data);
                            }
                        }

                        if (content_type_resp.data) {
                            self.content_type_list.push({
                                id: "null",
                                value: "請選擇"
                            });
                            content_type_resp.data.forEach(function(obj) {

                                obj.id = obj.id.uri;
                                obj.value = obj.name;

                                self.content_type_list.push(obj);
                            });
                            self.showFolder();
                        }

                    }
                )
            ).catch(error=>{
                //Handle errors here if something is expected to precess here
                EventBus.$emit("hideGlobalLoading");
                self.webix_functions.webix.showErrorMsg(error);

            });
        },
        setResourceList(array)
        {
            let self = this;
            array.forEach(function(obj) {
                if ( obj) {
                    self.resource_list.push(
                        {
                            metadata_id: obj.id.uri,
                            content_type: obj.educational.learning_resource_type.uri,
                            title: obj.general.title,
                            hkepid: obj.general.object_id.uri,
                            version: obj.life_cycle.version,
                            description: obj.general.description,
                            file: obj.technical.filename,
                            file_type: obj.technical.format,
                            size: obj.technical.size,
                            published: false,
                            allow_use: true
                        }
                    );
                }

            });
        },
        setSearchResourceList(array)
        {
            let self = this;
            if (array) {
                array.forEach(function(obj) {
                    if ( obj) {
                        self.search_resource_list.push(
                            {
                                metadata_id: obj.id.uri,
                                content_type: obj.educational.learning_resource_type.uri,
                                title: obj.general.title,
                                hkepid: obj.general.object_id.uri,
                                version: obj.life_cycle.version,
                                description: obj.general.description,
                                file: obj.technical.filename,
                                file_type: obj.technical.format,
                                size: obj.technical.size,
                                published: false,
                                allow_use: true
                            }
                        );
                    }

                });
            }

        },
        showFolder: function ()
        {
            let self = this;
            webix.ui({

                container:"my_folder",
                id:"my_folder",
                width: 680,
                height: 500,
                css: "my_folder",
                hidden: true,
                rows:[
                    {
                        cols:[
                            // { id:"my_folder_header", view:"label", label: "我的資源夾(暫存"+self.count+"個資源)" },
                            {
                                gravity: 4
                            },
                            { view:"button", type:"icon", icon:"times-circle", label:"", width: 30,
                                click: function() {
                                    if ($$("listing")) {
                                        $$("listing").filter();
                                    }
                                    if ($$("subcate_select_published")) {
                                        $$("subcate_select_published").setValue("null");
                                        $$("subcate_select_published").enable();
                                    }
                                    if ($$("searchbox")) {
                                        $$("searchbox").setValue("");
                                        $$("searchbox").enable();
                                    }
                                    $$("my_folder").hide();
                                }
                            }
                        ]
                    },
                    {
                        view:"tabview",
                        id: "tabview",
                        cells:[
                            // {
                            //     borderless:true,
                            //     header:"bookmark ("+self.count+")",
                            //     body: {
                            //         rows: [
                            //             {
                            //                 cols:[
                            //                     {
                            //                         view:"combo",
                            //                         id:"select_content_type",
                            //                         width:300,
                            //                         label:'',
                            //                         name:"content_type",
                            //                         value: "null",
                            //                         options:{
                            //                             body:{
                            //                                 data: self.content_type_list
                            //                             }
                            //                         },
                            //                         on: {
                            //                             onChange(value) {
                            //                                 console.log(value);
                            //                                 if (value === "null") {
                            //                                     $$("mydatatable").filter();
                            //                                 } else {
                            //                                     $$("mydatatable").filter("#content_type#", value);
                            //
                            //                                 }
                            //                             }
                            //                         }
                            //                     },
                            //                     { gravity: 4},
                            //                     { view:"button", click: self.add_to_sub_cate, type:"icon", icon:"plus", label:"加入sub-cate", width: 120 },
                            //                     { view:"button", click: self.refresh_row, type:"icon", icon:"undo", label:"更新", width: 60 },
                            //                     { view:"button", click: self.del_row, type:"icon", icon:"trash", label:"刪除", width: 60 }
                            //                 ]
                            //             },
                            //             {
                            //                 id: "mydatatable",
                            //                 view:"list",
                            //                 scrollX:false,
                            //                 select: true,
                            //                 multiselect: true,
                            //                 drag: true,
                            //                 css: "mydatatable",
                            //                 template:function(obj){
                            //                     var file_type_html = "";
                            //                     var file_type = obj.file_type;
                            //                     if (file_type) {
                            //                         file_type = self.mime_type[file_type];
                            //                     }
                            //                     if (obj.file_type) {
                            //                         file_type_html = "<div class='left file-type'><p class='file-"+file_type+"'>"+file_type+"</p></div>"
                            //                     }
                            //
                            //                     //get content type name
                            //                     var content_type_name = "";
                            //                     self.content_type_list.forEach(function(content_obj) {
                            //                         if (content_obj.id === obj.content_type) {
                            //                             content_type_name = content_obj.value;
                            //                         }
                            //                     });
                            //
                            //
                            //                     return "<div class='lom'>"+
                            //                         "<div class='left content'><p><b>"+obj.title+
                            //                         "</b><br>"+obj.description+"</p>" +
                            //                         file_type_html +
                            //
                            //                         "<p>"+self.common.formatSize(obj.size)+" <span class=\"webix_icon_btn fa-file\" style=\"max-width:32px;\"></span>"+obj.file+" <span class=\"webix_icon_btn fa-globe\" style=\"max-width:32px;\"></span> "+obj.hkepid+
                            //                         " <span class=\"webix_icon_btn fa-tag\" style=\"max-width:32px;\"></span> "+obj.version+" "+content_type_name+"</p></div>" +
                            //                         "<div class='right'><div class='edit_btn'><span class='webix_icon_btn fa-edit' style='max-width:32px;'></span></div></div></div>";
                            //                 },
                            //                 data: self.resource_list,
                            //                 onClick:{
                            //                     edit_btn:function(ev, id, html) {
                            //
                            //                         console.log(id);
                            //
                            //                     }
                            //                 },
                            //                 on: {
                            //                     "onBeforeDrag": function(context, ev) {
                            //                         context.html = "<div style='padding:8px;'>";
                            //                         for (var i=0; i< context.source.length; i++){
                            //                             context.html += context.from.getItem(context.source[i]).title + "<br>" ;
                            //                         }
                            //                         context.html += "</div>";
                            //                     },
                            //                     "onBeforeDrop": function (context, ev) {
                            //
                            //                         console.log(context.from.getItem(context.source[0]));
                            //
                            //
                            //                         var my_folder_list = [];
                            //                         //get all my folder resource list
                            //                         $$("mydatatable").data.each(function(obj) {
                            //                             my_folder_list.push(obj.hkepid);
                            //                         });
                            //
                            //                         //只接受其他table drag入來的row
                            //                         if (context.from.config.id !== "mydatatable") {
                            //
                            //                             for (var i=0; i< context.source.length; i++){
                            //                                 var new_item_hkepid = context.from.getItem(context.source[i]).hkepid;
                            //                                 //check is id existed
                            //                                 if (my_folder_list.indexOf(new_item_hkepid) !== -1) {
                            //                                     webix.message(new_item_hkepid+" existed (my folder)");
                            //                                     return false;
                            //                                 }
                            //
                            //                                 var details = { parent:context.parent, newId:webix.uid() };
                            //                                 //copy row content to listing table
                            //                                 context.from.copy( context.source[i], context.index, context.to, details);
                            //                                 my_folder_list.push(new_item_hkepid);
                            //
                            //                             }
                            //
                            //                             //刷新資源列表
                            //                             self.update_row(my_folder_list);
                            //                             return false;
                            //                         }
                            //                     },
                            //                     "onItemClick":function(id, e, trg){
                            //                         var index = self.item_select.indexOf(id);
                            //
                            //                         if ($$("mydatatable").isSelected(id) === true) {
                            //
                            //                             if (index > -1) {
                            //                                 self.item_select.splice(index, 1);
                            //                             }
                            //
                            //                             $$('mydatatable').unselect(id);
                            //                             return false;
                            //                         } else {
                            //                             self.item_select.push(id);
                            //                         }
                            //
                            //                         if (self.item_select.length > 0) {
                            //                             $$("mydatatable").select(self.item_select);
                            //
                            //                         }
                            //
                            //                         return false;
                            //                     }
                            //                 }
                            //             }
                            //         ]
                            //
                            //     }
                            //
                            // },
                            {
                                header:"搜尋資源",
                                body: {
                                    rows:[
                                        {
                                            view:"combo",
                                            value:"null",
                                            options: self.subject_list,
                                            id: "subject_filter",
                                            label: "科目",
                                            on: {
                                                onChange(value) {
                                                    //filter select search_content options

                                                    var options = self.content_type_list;
                                                    if (value !== "null") {
                                                        options = [];
                                                        if (self.content_type_list) {
                                                            self.content_type_list.forEach(function(obj) {
                                                                if (obj.subject) {
                                                                    if (obj.subject.uri_value) {
                                                                        if (obj.subject.uri_value.toUpperCase() === value) {
                                                                            options.push(obj);
                                                                        }
                                                                    }
                                                                }

                                                            });
                                                        }

                                                    }

                                                    $$("select_search_content_type").define("options", options);
                                                    $$("select_search_content_type").refresh();

                                                }
                                            }

                                        },
                                        {
                                            view:"combo",
                                            id:"select_search_content_type",
                                            label:'資源類型',
                                            name:"content_type",
                                            value: "null",
                                            options: self.content_type_list,
                                            on: {
                                                onChange(value) {

                                                    self.update_search_tab_list(value);

                                                }
                                            }
                                        },

                                        {
                                            view:"search",
                                            placeholder:"搜尋組合資源...",
                                            id: "search",
                                            on: {
                                                onTimedKeyPress: function()
                                                {
                                                    self.filter_search_table();
                                                }
                                            }
                                        },
                                        {
                                            id: "search_mydatatable",
                                            view:"list",
                                            scrollX:false,
                                            select: true,
                                            multiselect: true,
                                            drag: true,
                                            css: "mydatatable",
                                            template:function(obj){
                                                var file_type = obj.file_type;
                                                if (file_type) {
                                                    file_type = self.mime_type[file_type];
                                                }
                                                if (obj.file_type) ;

                                                //get content type name
                                                var content_type_name = "";
                                                self.content_type_list.forEach(function(content_obj) {
                                                    if (content_obj.id === obj.content_type) {
                                                        content_type_name = content_obj.value;
                                                    }
                                                });


                                                return "<div class='lom'>"+
                                                    "<div class='left content'><p><b>"+obj.title+"</b></p><br>"+

                                                    "<p> <span class=\"webix_icon_btn fa-globe\" style=\"max-width:32px;\"></span>ID: "+obj.hkepid.replace("hkep-lo:", "")+
                                                    " <span class=\"webix_icon_btn fa-tag\" style=\"max-width:32px;\"></span>版本: "+obj.version +
                                                    " <span class=\"webix_icon_btn fa-copyright\" style=\"max-width:32px;\"></span>資源類型: "+self.content_type_function.webix.getNameById(self.content_type_list, obj.content_type)+"</p></div>"+

                                                    "<div class='right'><div class='edit_btn'><span class='webix_icon_btn fa-edit' style='max-width:32px;'></span></div></div>" +
                                                    "</div>";
                                            },
                                            data: self.search_resource_list,
                                            onClick:{
                                                edit_btn:function(ev, id, html) {

                                                    var item = this.getItem(id);
                                                    var url = "/set_group_resource?content_type_id="+item.content_type+"&content_type=group&id="+item.hkepid;

                                                    window.open(url, '_blank');

                                                }
                                            },
                                            on: {
                                                "onBeforeDrag": function(context, ev) {
                                                    context.html = "<div style='padding:8px;'>";
                                                    for (var i=0; i< context.source.length; i++){
                                                        context.html += context.from.getItem(context.source[i]).title + "<br>" ;
                                                    }
                                                    context.html += "</div>";
                                                },
                                                "onBeforeDrop": function (context, ev) {

                                                    console.log(context.from.getItem(context.source[0]));


                                                    var my_folder_list = [];
                                                    //get all my folder resource list
                                                    $$("search_mydatatable").data.each(function(obj) {
                                                        my_folder_list.push(obj.hkepid);
                                                    });

                                                    //只接受其他table drag入來的row
                                                    if (context.from.config.id !== "search_mydatatable") {

                                                        for (var i=0; i< context.source.length; i++){
                                                            var new_item_hkepid = context.from.getItem(context.source[i]).hkepid;
                                                            //check is id existed
                                                            if (my_folder_list.indexOf(new_item_hkepid) !== -1) {
                                                                webix.message(new_item_hkepid+" existed (my folder)");
                                                                return false;
                                                            }

                                                            var details = { parent:context.parent, newId:webix.uid() };
                                                            //copy row content to listing table
                                                            context.from.copy( context.source[i], context.index, context.to, details);
                                                            my_folder_list.push(new_item_hkepid);

                                                        }

                                                        //刷新資源列表
                                                        self.update_row(my_folder_list);
                                                        return false;
                                                    }
                                                },
                                                "onItemClick":function(id, e, trg){
                                                    var index = self.item_select.indexOf(id);

                                                    if ($$("search_mydatatable").isSelected(id) === true) {

                                                        if (index > -1) {
                                                            self.item_select.splice(index, 1);
                                                        }

                                                        $$('search_mydatatable').unselect(id);
                                                        return false;
                                                    } else {
                                                        self.item_select.push(id);
                                                    }

                                                    if (self.item_select.length > 0) {
                                                        $$("search_mydatatable").select(self.item_select);

                                                    }

                                                    return false;
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }

                ]
            });
        },
        /**
         *
         */
        getSearchParam: function(key, search) {
            key = key.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp(key + ':([^&#]*)');
            var results = regex.exec(search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
        /*
         * 刷新資源列表和儲存到DB
         */
        update_row: function(arr_id)
        {
            let self = this;
            var num = arr_id.length;
            var resources = arr_id;
            self.update_file_header(num);

            self.api.saveMyFolder(self.memberid, resources).then(function(data) {
                console.log(data);
                webix.message("success");
            });

        },
        /**
         * 刪除資源和儲存到DB
         */
        del_row: function()
        {
            let self = this;

            var resources = [];
            var arr_obj_selected_id = $$("mydatatable").getSelectedId(true);
            var num = 0;
            var arr_selected_id = [];

            if (arr_obj_selected_id.length > 0) {
                arr_obj_selected_id.forEach(function(id) {
                    console.log(id);
                    arr_selected_id.push($$("mydatatable").getItem(id).hkepid);
                    $$("mydatatable").remove(id);
                });
                $$("mydatatable").data.each(function(obj){

                    // if (arr_selected_id.indexOf(this.getItem(id).hkepid) != -1) {
                    //     //this.remove(id);
                    //
                    // } else {
                    resources.push(obj.hkepid);
                    num++;
                    // }
                });

                self.update_file_header(num);

                console.log(resources);

                self.api.saveMyFolder(self.memberid, resources).then(function(data) {
                    console.log(data);
                    webix.message("success");
                });
            }


        },
        update_search_tab_list(content_type)
        {
            let self = this;
            $$("search_mydatatable").clearAll();
            $$("search").setValue("");

            $$("search_mydatatable").load(function () {
                return self.api.getResourceByContentType(content_type, self.status).then(function (resp) {
                    self.search_resource_list = [];
                    self.setSearchResourceList(resp.data);

                    return self.search_resource_list;
                });

            });
        },
        filter_search_table()
        {
            if ($$("select_search_content_type").getValue() === "null") {
                webix.message("請先選擇資源類型");
            }


            var search_value = $$("search").getValue();

            if (search_value === "") {
                $$("search_mydatatable").filter();
                return true;
            }

            $$("search_mydatatable").filter(function(obj) {
                //filter by multiple properties
                var filter = [obj.title, obj.description, obj.hkepid, obj.file, obj.version].join("|");
                filter = filter.toString().toLowerCase();

                if (search_value !== "") {
                    if ((filter.indexOf(search_value) !== -1)) {
                        return true;
                    }
                }
            });
        },
        refresh_row: function()
        {
            let self = this;
            $$("mydatatable").clearAll();

            $$("mydatatable").load(function () {
                return self.api.getMyFolderByMemberId(self.memberid).then(function (resp) {
                    self.update_file_header(resp.data.count);
                    self.resource_list = [];
                    self.setResourceList(resp.data.data);

                    return self.resource_list;
                });

            }).then(function() {
                var filter = $$("select_content_type").getValue();

                if (filter !== "null") {
                    $$("mydatatable").filter("#content_type#", filter);
                }
            });
        },
        add_to_sub_cate: function()
        {
            console.log("emit event add_to_sub_cate");
            //go to MyFolder.vue
            EventBus.$emit('add_to_sub_cate', $$("mydatatable"));
        },
        update_file_header: function(num)
        {

            $$("my_folder_header").define("label", "我的資源夾(暫存"+num+"個資源)");
            $$("my_folder_header").refresh();
            var tabbar = $$("tabview").getTabbar();
            tabbar.config.options[0].value = "bookmark ("+num+")";
            tabbar.render();

        },
        /**
         * add resource to bookmark
         * @param objs
         */
        add_to_bookmark: function(objs)
        {

            var all_exist_id = [];
            $$("mydatatable").data.each(function(obj) {
                all_exist_id.push(obj.hkepid);
            });

            if (objs) {
                objs.forEach(function(obj) {

                    if (all_exist_id.indexOf(obj.hkepid) !== -1) {
                        webix.message(obj.hkepid+" existed (sub-cate)");
                        return false;
                    }
                    $$("mydatatable").add( obj, 0 );
                });
            }

            var my_folder_list = [];
            //get all my folder resource list
            $$("mydatatable").data.each(function(obj) {
                my_folder_list.push(obj.hkepid);
            });

            this.update_row(my_folder_list);

        }
    },


}

/* script */
            const __vue_script__$3 = script$3;
            
/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"my_folder"}})};
var __vue_staticRenderFns__$3 = [];

  /* style */
  const __vue_inject_styles__$3 = function (inject) {
    if (!inject) return
    inject("data-v-63ca4e2b_0", { source: "\n#my_folder{position:absolute;right:0;z-index:2;background:#fff\n}\n.my_folder{width:680px;border-radius:3px;border:1px solid #4d4d4d;padding:5px\n}\n#my_folder button{border:1px solid #95a5a6\n}\n.mydatatable .webix_list_item{height:auto!important\n}\n.mydatatable .content{min-width:550px;max-width:560px\n}\n.mydatatable .lom .left{float:left\n}\n.mydatatable .lom .right{float:right\n}\n.mydatatable .lom .right .edit_btn{padding:10px\n}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* component normalizer */
  function __vue_normalize__$3(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "MyFolder.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    {
      let hook;
      if (style) {
        hook = function(context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render;
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context)
          };
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate;
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__$3() {
    const head = document.head || document.getElementsByTagName('head')[0];
    const styles = __vue_create_injector__$3.styles || (__vue_create_injector__$3.styles = {});
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id;
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

      if (!style.ids.includes(id)) {
        let code = css.source;
        let index = style.ids.length;

        style.ids.push(id);

        if (css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */';
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']');
        }

        if (!style.element) {
          const el = style.element = document.createElement('style');
          el.type = 'text/css';

          if (css.media) el.setAttribute('media', css.media);
          if (isOldIE) {
            el.setAttribute('data-group', group);
            el.setAttribute('data-next-index', '0');
          }

          head.appendChild(el);
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'));
          style.element.setAttribute('data-next-index', index + 1);
        }

        if (style.element.styleSheet) {
          style.parts.push(code);
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n');
        } else {
          const textNode = document.createTextNode(code);
          const nodes = style.element.childNodes;
          if (nodes[index]) style.element.removeChild(nodes[index]);
          if (nodes.length) style.element.insertBefore(textNode, nodes[index]);
          else style.element.appendChild(textNode);
        }
      }
    }
  }
  /* style inject SSR */
  

  
  var MyFolder = __vue_normalize__$3(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    __vue_create_injector__$3,
    undefined
  )

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var script$4 = {
    name: "HkepMsgPop",
    props: {
        img:String,
        lang: {
            type: String,
            default: "zh"
        }
    },
    data() {
        return {
            isShow:false,
            content: []
        }
    },
    methods: {
        show() {
            this.isShow = true;
        },
        hide() {
            this.isShow = false;
        },
        setContent(content) {
            this.content = content;
        }
    }
}

/* script */
            const __vue_script__$4 = script$4;
            
/* template */
var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],attrs:{"id":"hkep_msg_pop"}},[_c('div',{staticClass:"popup-box"},[_c('a',{staticClass:"btn-close dark",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.hide}},[_c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 80 80"}},[_c('path',{attrs:{"d":"M76 11.251l-7.252-7.251-28.748 28.749-28.749-28.749-7.251 7.251 28.749 28.749-28.749 28.748 7.251 7.252 28.749-28.748 28.748 28.748 7.252-7.252-28.748-28.748z"}})])])]),_vm._v(" "),_c('div',{attrs:{"id":"hkep_msg_pop_content"}},[(_vm.img)?[_c('img',{attrs:{"id":"alert_img","src":_vm.img}})]:_vm._e(),_vm._v(" "),_vm._l((_vm.content),function(text){return [_c('div',{staticClass:"chi",domProps:{"innerHTML":_vm._s(text)}})]})],2)]),_vm._v(" "),_c('div',{staticClass:"dark-mask",on:{"click":_vm.hide}})])};
var __vue_staticRenderFns__$4 = [];

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* component normalizer */
  function __vue_normalize__$4(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "HkepMsgPop.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var HkepMsgPop = __vue_normalize__$4(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    undefined,
    undefined
  )

export { HkepHello, HkepWorld, HkepLoading, MyFolder, HkepMsgPop };



//////////////////
// WEBPACK FOOTER
// ./node_modules/hkep-vue-lib/lib/index.js
// module id = f+Zw
// module chunks = 2 3 4 5 6